/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClass interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClass(value) {
    if (!('GameAccountName' in value) || value['GameAccountName'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClassFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClassFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClassFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'GameAccountName': json['GameAccountName'],
    };
}
export function FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClassToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClassToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClassToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'GameAccountName': value['GameAccountName'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClass.js.map